export default "__VITE_ASSET__DzwWxgEa__"